import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from "react-modal";
import "./Feedback.css";

Modal.setAppElement("#root");

const Feedback = () => {
  const [textContent, setTextContent] = useState("");
  const [classification, setClassification] = useState("");
  const [remarks, setRemarks] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    // Fetch text content from the correct endpoint
    axios
      .get("https://twitter-hate-speech-29wb.onrender.com/api/reviews/post/")
      .then((response) => {
        // Backend now returns direct object with text property
        setTextContent(response.data.text);
      })
      .catch((error) => {
        console.error("Error fetching text content:", error);
      });
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    const reviewData = {
      text: textContent,
      classification: classification,
      remarks: remarks
    };

    axios
      .post("https://twitter-hate-speech-29wb.onrender.com/api/reviews/post/", reviewData)
      .then((response) => {
        setModalIsOpen(true);
      })
      .catch((error) => {
        if (error.response) {
          // Server responded with a status other than 200 range
          console.error("Error response:", error.response.data);
        } else if (error.request) {
          // Request was made but no response was received
          console.error("Error request:", error.request);
        } else {
          // Something happened in setting up the request
          console.error("Error message:", error.message);
        }
      });
  };

  return (
    <>
      <section id="review" className="review mt-4">
        <div className="container feed">
          <div className="text-center">
            <h2>Review a prediction</h2>
          </div>
          <form className="review-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="textContent">Text content</label>
              <input
                name="textContent"
                className="form-control"
                id="textContent"
                readOnly
                value={textContent}
              />
            </div>
            <div className="form-group">
              <label htmlFor="classification">Select classification</label>
              <select
                name="classification"
                className="form-control select-control"
                id="classification"
                required
                value={classification}
                onChange={(e) => setClassification(e.target.value)}
              >
                <option value="">Choose an option</option>
                <option value="1">Hate Speech</option>
                <option value="0">Non-hate Speech</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="remarks">What do you think about the prediction's accuracy?</label>
              <textarea
                name="remarks"
                className="form-control"
                id="remarks"
                required
                placeholder="Enter any additional remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>
            <div className="text-center">
              <button type="submit" className="submit-btn">
                Submit review
              </button>
            </div>
          </form>
        </div>
      </section>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Review Submitted"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2>Review Submitted</h2>
        <p>Thank you for your feedback!</p>
        <button onClick={() => setModalIsOpen(false)}>Close</button>
      </Modal>
    </>
  );
};

export default Feedback;